import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { UtilitiesService } from '../../core/services/utilities.service';
import { RequestOption } from '../model/common.model';
import { GetAllResponse } from '../model/restful-api.model';
import { API_URL } from './../enums/api-enums';
import { SingleResponse } from './../model/restful-api.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationAccessStatusService {

  baseUrl = environment.portalURL;
  constructor(
    private util: UtilitiesService
  ) { }

  getData(requestOption: RequestOption, sso, supplierName, gsl, applications): Observable<GetAllResponse<any>> {
    let params = new HttpParams();
    if (sso) {
      params = params.append('sso', sso);
    }
    if (supplierName) {
      params = params.append('supplierName', supplierName);
    }
    if (gsl) {
      params = params.append('gslNumber', gsl);
    }
    if (applications) {
      params = params.append('applications', applications);
    }
    if (requestOption.pagingOptions.sort.sortBy && requestOption.pagingOptions.sort.sortOrder) {
      params = params.append('sortBy', requestOption.pagingOptions.sort.sortBy);
      params = params.append('sortDirection', requestOption.pagingOptions.sort.sortOrder);
    }
    params = params.append('size', requestOption.pagingOptions.size.toString());
    params = params.append('page', requestOption.pagingOptions.number.toString());
    return this.util.req.httpGet<GetAllResponse<any>>(`${this.baseUrl + API_URL.APPLICATION_ACCESS}?${params}`);
  }

  getSupplierById(id): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.APPLICATION_ACCESS + '/' + id);
  }

  getStatus(sso: string, appName: string): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.APPLICATION_ACCESS + API_URL.REVOKE_ACCESS
      + '?sso=' + sso + '&application=' + appName);
  }

  getApplications(): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.APPLICATION_ACCESS + '/applications');
  }

  searchSSO(sso): Observable<SingleResponse<any>> {
    return this.util.req.httpGet<SingleResponse<any>>(this.baseUrl + API_URL.APPLICATION_ACCESS + '/search?sso=' + sso);
  }

  revokeAccess(model): Observable<SingleResponse<any>> {
    const requestModel = {
      reason: model.reason,
      application: model.application,
      supplierSso: model.supplierSso,
      fullName: model.fullName,
      email: model.email
    };
    return this.util.req.httpPost<SingleResponse<any>>(this.baseUrl + API_URL.APPLICATION_ACCESS + API_URL.REVOKE_ACCESS, requestModel);
  }
}
